import {Link} from "react-router-dom";
import './Home.css';
import {useStore} from "../../store/store";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {APIBASE} from "../../config/Pfalzmarkt.config";

export default function Home(props) {
    const [globalState, dispatch] = useStore();
    const [numberOfOrders, setNumberOfOrders] = useState(0);
    const header = "Authorization: Bearer " + localStorage.getItem("token");

    const fetchAnzahlBestellungen = async () => {
        try {
            const response = await axios.get(
                APIBASE + 'api/anzahlBestellungen', {headers: header}
            );
            const data = await response.data;
            setNumberOfOrders(data.anzahl);
        } catch (err) {
            console.log(err);
            if (401 === err.response.status) {
                dispatch('IS_401_ERROR', true);
                dispatch('SET_AUTHTOKEN', null);

            }
            console.log(err.message); // Todo: Errorhandling

        }
    }


    useEffect(() => {
        fetchAnzahlBestellungen();
    }, [globalState.token]);

    return (
        <>
            {globalState.token &&
                <div className="row">
                    <div className="col-sm-3 p-1">
                        <div className="card">
                            <Link to="/bestellungen">
                                <div className="card-body">
                                    <h5 className="card-title">Bestellungen</h5>
                                    <p className="card-text">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100"
                                             fill="currentColor"
                                             className="bi bi-truck" viewBox="0 0 16 16">
                                            <path
                                                d="M0 3.5A1.5 1.5 0 0 1 1.5 2h9A1.5 1.5 0 0 1 12 3.5V5h1.02a1.5 1.5 0 0 1 1.17.563l1.481 1.85a1.5 1.5 0 0 1 .329.938V10.5a1.5 1.5 0 0 1-1.5 1.5H14a2 2 0 1 1-4 0H5a2 2 0 1 1-3.998-.085A1.5 1.5 0 0 1 0 10.5zm1.294 7.456A2 2 0 0 1 4.732 11h5.536a2 2 0 0 1 .732-.732V3.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .294.456M12 10a2 2 0 0 1 1.732 1h.768a.5.5 0 0 0 .5-.5V8.35a.5.5 0 0 0-.11-.312l-1.48-1.85A.5.5 0 0 0 13.02 6H12zm-9 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m9 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2"></path>
                                        </svg>
                                        &nbsp;
                                        <button type="button" className="btn btn-secondary btn-sm"><span
                                            className="badge badge-">{numberOfOrders}</span>
                                        </button>
                                    </p>

                                </div>
                            </Link>

                        </div>
                    </div>
                    <div className="col-sm-3  p-1">
                        <div className="card">
                            <Link to="/telefonliste">
                                <div className="card-body">
                                    <h5 className="card-title">Telefonliste</h5>
                                    <p className="card-text">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100"
                                             fill="currentColor"
                                             className="bi bi-people-fill" viewBox="0 0 16 16">
                                            <path
                                                d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5.784 6A2.24 2.24 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.3 6.3 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"/>
                                        </svg>
                                    </p>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className="col-sm-3  p-1">
                        <div className="card">
                            <Link to="/meldungen">
                                <div className="card-body">
                                    <h5 className="card-title">Meldung</h5>
                                    <p className="card-text">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100"
                                             fill="currentColor"
                                             className="bi bi-arrow-repeat" viewBox="0 0 16 16">
                                            <path
                                                d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41m-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9"/>
                                            <path fillRule="evenodd"
                                                  d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5 5 0 0 0 8 3M3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9z"/>
                                        </svg>
                                    </p>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className="col-sm-3  p-1">
                        <div className="card">
                            <Link to="https://qlik.pfalzmarkt.de/hub" target="_blank">
                                <div className="card-body">
                                    <h5 className="card-title">Portal – Qlik</h5>
                                    <p className="card-text">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100"
                                             fill="currentColor"
                                             className="bi bi-cash-coin" viewBox="0 0 16 16">
                                            <path fillRule="evenodd"
                                                  d="M11 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8m5-4a5 5 0 1 1-10 0 5 5 0 0 1 10 0"/>
                                            <path
                                                d="M9.438 11.944c.047.596.518 1.06 1.363 1.116v.44h.375v-.443c.875-.061 1.386-.529 1.386-1.207 0-.618-.39-.936-1.09-1.1l-.296-.07v-1.2c.376.043.614.248.671.532h.658c-.047-.575-.54-1.024-1.329-1.073V8.5h-.375v.45c-.747.073-1.255.522-1.255 1.158 0 .562.378.92 1.007 1.066l.248.061v1.272c-.384-.058-.639-.27-.696-.563h-.668zm1.36-1.354c-.369-.085-.569-.26-.569-.522 0-.294.216-.514.572-.578v1.1zm.432.746c.449.104.655.272.655.569 0 .339-.257.571-.709.614v-1.195z"/>
                                            <path
                                                d="M1 0a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4.083q.088-.517.258-1H3a2 2 0 0 0-2-2V3a2 2 0 0 0 2-2h10a2 2 0 0 0 2 2v3.528c.38.34.717.728 1 1.154V1a1 1 0 0 0-1-1z"/>
                                            <path d="M9.998 5.083 10 5a2 2 0 1 0-3.132 1.65 6 6 0 0 1 3.13-1.567"/>
                                        </svg>
                                    </p>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className="col-sm-3  p-1">
                        <div className="card">
                            <Link to="/maschinenboerse">
                                <div className="card-body">
                                    <h5 className="card-title">Maschinenbörse</h5>
                                    <p className="card-text">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100"
                                             fill="currentColor"
                                             className="bi bi-car-front-fill" viewBox="0 0 16 16">
                                            <path
                                                d="M2.52 3.515A2.5 2.5 0 0 1 4.82 2h6.362c1 0 1.904.596 2.298 1.515l.792 1.848c.075.175.21.319.38.404.5.25.855.715.965 1.262l.335 1.679q.05.242.049.49v.413c0 .814-.39 1.543-1 1.997V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.338c-1.292.048-2.745.088-4 .088s-2.708-.04-4-.088V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.892c-.61-.454-1-1.183-1-1.997v-.413a2.5 2.5 0 0 1 .049-.49l.335-1.68c.11-.546.465-1.012.964-1.261a.8.8 0 0 0 .381-.404l.792-1.848ZM3 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2m10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2M6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2zM2.906 5.189a.51.51 0 0 0 .497.731c.91-.073 3.35-.17 4.597-.17s3.688.097 4.597.17a.51.51 0 0 0 .497-.731l-.956-1.913A.5.5 0 0 0 11.691 3H4.309a.5.5 0 0 0-.447.276L2.906 5.19Z"/>
                                        </svg>
                                    </p>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className="col-sm-3  p-1">
                        <div className="card">
                            <Link to="/streckengeschaeft">
                                <div className="card-body">
                                    <h5 className="card-title">Streckengeschäft</h5>
                                    <p className="card-text">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100"
                                             fill="currentColor"
                                             className="bi bi-cart4" viewBox="0 0 16 16">
                                            <path
                                                d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5M3.14 5l.5 2H5V5zM6 5v2h2V5zm3 0v2h2V5zm3 0v2h1.36l.5-2zm1.11 3H12v2h.61zM11 8H9v2h2zM8 8H6v2h2zM5 8H3.89l.5 2H5zm0 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0m9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0"/>
                                        </svg>
                                    </p>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className="col-sm-3  p-1">
                        <div className="card">
                            <Link to="/abrechnungen">
                                <div className="card-body">
                                    <h5 className="card-title">Abrechnungen</h5>
                                    <p className="card-text">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100"
                                             fill="currentColor"
                                             className="bi bi-cart4" viewBox="0 0 16 16">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                 fill="currentColor" className="bi bi-truck" viewBox="0 0 16 16">
                                                <path
                                                    d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-9 8c0 1 1 1 1 1h5v-1a2 2 0 0 1 .01-.2 4.49 4.49 0 0 1 1.534-3.693Q8.844 9.002 8 9c-5 0-6 3-6 4m7 0a1 1 0 0 1 1-1v-1a2 2 0 1 1 4 0v1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1zm3-3a1 1 0 0 0-1 1v1h2v-1a1 1 0 0 0-1-1"/>
                                            </svg>
                                        </svg>
                                    </p>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            }
        </>
    )
        ;
}